'use client';

import Link from 'next/link';
import { useEffect } from 'react';
import { Flex, Text, useDisclosure } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { PATHS } from '@/config/paths';
import { Modal } from '@/components/elements/Modal';
import { Thumb } from '@/components/elements/Thumb';

export const ModalUnauthenticated = () => {
  const t = useT();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const pathname =
    typeof window !== 'undefined' ? window.location.pathname : '';

  useEffect(() => {
    window.addEventListener('open-unauthenticated-modal', onOpen);
    return () =>
      window.removeEventListener('open-unauthenticated-modal', onOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      showCloseButton={false}
      containerProps={{
        alignItems: 'center',
      }}
      contentProps={{
        w: '23.5rem',
        bg: 'background.inverse',
        p: '2xl',
        borderRadius: '2xs',
        gap: 'l',
      }}
      headerContent={
        <Thumb src="/assets/eqiplus-logo-white.png" width={95} height={33} />
      }
    >
      <Flex direction="column" gap="l" color="content.inverse">
        <Text size="xl">{t('modalUnauthenticated.title')}</Text>
        <Flex
          aria-label="button-login-modal-unauthenticated"
          as={Link}
          href={`${PATHS.auth.login}?href=${pathname}`}
          target="_blank"
          justifyContent="center"
          alignItems="center"
          h="3.25rem"
          bgColor="action.active.brandLight"
          borderRadius="2xs"
          transition="background-color 0.2s"
          _hover={{
            bg: 'action.hover.brandLight',
          }}
        >
          <Text size="label.l" color="content.alwaysLight">
            {t('modalUnauthenticated.loginButton')}
          </Text>
        </Flex>
        <Text size="m" textAlign="center" w="full">
          {t('modalUnauthenticated.registerQuestion')}
          <Text
            aria-label="button-register-modal-unauthenticated"
            size="m"
            as={Link}
            href={`${PATHS.profile.register}?href=${pathname}`}
            target="_blank"
            fontWeight="semibold"
            ml="2xs"
          >
            {t('modalUnauthenticated.clickHere')}
          </Text>
        </Text>
      </Flex>
    </Modal>
  );
};
